export default __webpack_public_path__ + "static/media/penguin.cba663fa.ogg";